<template>
  <div id="app">
    <div v-if="shopSettings.view === 'home'" class="cart-main">
      <div class="container">
        <div class="row">
          <div v-if="showSidebar" class="col-md-4 col-lg-3">
            <FiltersSidebar />
          </div>
          <div :class="showSidebar ? 'col-md-8' : 'col-md-12'">
            <router-view> </router-view>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="col-md-12">
        <div class="container">
          <CartIcon class="cartIcon" />
          <router-view> </router-view>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/fonts.scss";
import FiltersSidebar from "@/components/Sidebar/FiltersSidebar";
import DefaultSidebar from "@/components/Sidebar/DefaultSidebar";
import CartIcon from "@/components/CartIcon";
import { createNamespacedHelpers } from "vuex";

const categoriesMapper = createNamespacedHelpers("categories");
const productsMapper = createNamespacedHelpers("products");

export default {
  name: "app",
  components: {
    CartIcon,
    FiltersSidebar,
    DefaultSidebar,
  },

  computed: {
    ...categoriesMapper.mapGetters({
      categories: "categories",
    }),

    showSidebar() {
      const noSidebarRoutes = ["product", "wizard", "cart", "checkout"];
      return !noSidebarRoutes.find((route) => this.$route.name === route);
    },
  },

  methods: {
    ...categoriesMapper.mapActions(["getCategories"]),
    ...productsMapper.mapActions({
      getProducts: "getProducts",
    }),
  },

  async created() {
    this.getProducts();
    if (this.shopSettings.view === "category") {
      let path = `/category/${this.shopSettings.categId}`;
      if (path != this.$route.path) {
        this.$router.push(`/category/${this.shopSettings.categId}`);
      }
    } else {
      await this.getCategories();
      let categories = {};
      this.categories.map((categoryItem) => {
        if (categoryItem.parent === 0) {
          categoryItem.children = [];
          categories[categoryItem.id] = categoryItem;
        }
      });
      this.categories.map((categoryItem) => {
        if (categoryItem.parent !== 0) {
          categories[categoryItem.parent].children = categoryItem;
        }
      });
    }
  },
};
</script>
<style>
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
}

.loader {
  color: var(--theme);
  font-size: 10px;
  margin: 80px auto;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

.loader:before,
.loader:after {
  content: "";
  position: absolute;
  top: 0;
}

.loader:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.loader:after {
  left: 3.5em;
}

@-webkit-keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }

  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }

  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 11px;
}

.card .img-wrap {
  overflow: hidden;
}

.card-product {
  margin-bottom: 1rem;
}

.card-product:after {
  content: "";
  display: table;
  clear: both;
  visibility: hidden;
}

.card-product .img-wrap {
  border-radius: 3px 3px 0 0;
  overflow: hidden;
  position: relative;
  height: 190px;
  text-align: center;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
}

.card-product .img-wrap img {
  max-height: 100%;
  width: 100%;
  display: inline-block;
  object-fit: cover;
  padding: 12px;
  border-radius: 16px;
  overflow: hidden;
}

.card-product .info-wrap {
  overflow: hidden;
  padding: 15px;
}

.card-product .action-wrap {
  padding-top: 4px;
  margin-top: 4px;
}

.card-product .bottom-wrap {
  padding: 15px;
  border-top: 1px solid #eee;
}

.card-product .title {
  font-weight: bolder;
  margin-top: 0;
}

.card-product .btn-overlay {
  transition: 0.5s;
  opacity: 0;
  left: 0;
  bottom: 0;
  color: #fff;
  width: 100%;
  padding: 5px 0;
  font-size: 12px;
  text-align: center;
  position: absolute;
  text-transform: uppercase;
  background: rgba(0, 0, 0, 0.5);
}

.card-product:hover .btn-overlay {
  opacity: 1;
}

.card-product:hover {
  box-shadow: 0 4px 15px rgba(153, 153, 153, 0.3);
  transition: 0.5s;
}

#app .btn,
#app .utd-btn {
  font-size: 1.6rem;
  /* padding: 0.2rem 0.6rem !important; */
  padding: 0.7rem 1.4rem !important;
  /* font-size: 1.3rem; */
  line-height: 1.5;
  border-radius: 0.78rem;
}

.btn-border {
  border: 2px solid var(--theme);
  color: var(--theme);
}

.btn-border:hover {
  background-color: rgba(var(--theme-rgb), 0.2);
  color: var(--theme);
}

.btn:disabled {
  background-color: #ddd;
  color: #555;
  border: none;
}

.price-wrap {
  font-size: 18px;
}

.gallery-wrap .img-big-wrap img {
  height: 450px;
  width: auto;
  display: inline-block;
  cursor: zoom-in;
}

.gallery-wrap .img-small-wrap {
  text-align: center;
}

.gallery-wrap .img-small-wrap .item-gallery {
  width: 60px;
  height: 60px;
  border: 1px solid #ddd;
  margin: 7px 2px;
  display: inline-block;
  overflow: hidden;
}

.gallery-wrap .img-small-wrap img {
  max-width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
  cursor: zoom-in;
}

.gallery-wrap .img-small-wrap img:hover {
  filter: brightness(1.1);
  cursor: zoom-in;
}

hr,
td,
th,
.l-section,
.vc_column_container,
.vc_column-inner,
.w-author,
.w-comments-list,
.w-pricing-item-h,
.w-profile,
.w-separator,
.w-sharing-item,
.w-tabs-list,
.w-tabs-section,
.w-tabs-section-header:before,
.w-tabs.layout_timeline.accordion .w-tabs-section-content,
.g-tags > a,
.w-testimonials.style_1 .w-testimonial-h,
.widget_calendar #calendar_wrap,
.l-main .widget_nav_menu > div,
.l-main .widget_nav_menu .menu-item a,
.widget_nav_menu .menu-item.menu-item-has-children + .menu-item > a,
.select2-container a.select2-choice,
.smile-icon-timeline-wrap .timeline-line,
.woocommerce .login,
.woocommerce .track_order,
.woocommerce .checkout_coupon,
.woocommerce .lost_reset_password,
.woocommerce .register,
.woocommerce .cart.variations_form,
.woocommerce .commentlist .comment-text,
.woocommerce .comment-respond,
.woocommerce .related,
.woocommerce .upsells,
.woocommerce .cross-sells,
.woocommerce .checkout #order_review,
.widget_price_filter .ui-slider-handle,
.widget_layered_nav ul,
.widget_layered_nav ul li,
#bbpress-forums fieldset,
.bbp-login-form fieldset,
#bbpress-forums .bbp-body > ul,
#bbpress-forums li.bbp-header,
.bbp-replies .bbp-body,
div.bbp-forum-header,
div.bbp-topic-header,
div.bbp-reply-header,
.bbp-pagination-links a,
.bbp-pagination-links span.current,
span.bbp-topic-pagination a.page-numbers,
.bbp-logged-in,
.tribe-events-list-separator-month span:before,
.tribe-events-list-separator-month span:after,
.type-tribe_events + .type-tribe_events,
.gform_wrapper .gsection,
.gform_wrapper .gf_page_steps,
.gform_wrapper li.gfield_creditcard_warning,
.form_saved_message {
  border-color: #ebebeb;
}

.badge {
  border-radius: 10px;
  padding: 5px 10px;
}

.badge-normal {
  color: rgb(92, 92, 92);
  background: #ebebeb !important;
  font-weight: unset;
  padding: 7px 10px;
  font-size: 1.5rem !important;
}

.cart-main .cart-item {
  padding-left: 10px;
}
</style>
